
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.052 11c.521 0 .948.427.948.949v.102a.952.952 0 01-.948.949H3.948A.95.95 0 013 12.051v-.102A.95.95 0 013.948 11h16.104zm0 5c.521 0 .948.427.948.949v.102a.952.952 0 01-.948.949H3.948A.95.95 0 013 17.051v-.102A.95.95 0 013.948 16h16.104zm0-10c.521 0 .948.427.948.949v.102a.952.952 0 01-.948.949H3.948A.95.95 0 013 7.051v-.102A.95.95 0 013.948 6h16.104z"}})])
          )
        }
      }
    